<template>
  <v-container>
    <v-content>
      <h1
        v-if="greeting.length > 0"
        class="text-center primary--text"
        name="'alert_' + status "
        v-html="
          getContent('dashboard header greeting').replace(
            '{{greeting}}',
            greeting
          )
        "
      ></h1>
      <h1 v-else class="text-center primary--text">
        {{ getContent('dashboard header') }}
      </h1>
      <v-layout justify-center row-wrap>
        <v-row class="justify-center align-center">
          <v-col :lg="4" :md="4" :sm="12">
            <tile
              id="planningTile"
              name="planning"
              route-to="planning"
              show-divider
              :header="'Produktionsplanung'"
              :sub-header="''"
              :content="''"
            ></tile>
          </v-col>
          <v-col :lg="4" :md="4" :sm="12">
            <tile
              id="reportsTile"
              name="reports"
              route-to="reports"
              show-divider
              :header="'Reports'"
              :sub-header="''"
              :content="''"
            ></tile>
          </v-col>
          <v-col :lg="4" :md="4" :sm="12">
            <tile
              id="oneProcessTile"
              name="oneProcess"
              route-to="oneProcess"
              show-divider
              :header="'One Process'"
              :sub-header="''"
              :content="''"
            ></tile>
          </v-col>
          <!--
          <v-col :lg="4" :md="4" :sm="12">
            <tile
              id="partialBatchesPlanningTile"
              name="partialBatchesPlanning"
              routeTo="partialBatchesPlanning"
              showDivider
              :header="'Restlosplanung'"
              :subHeader="''"
              :content="''"
            ></tile>
          </v-col>
          -->
          <!--
        <v-col :lg="4" :md="4" :sm="12">
          <tile
            id="HistoryTile"
            name="history"
            routeTo="history"
            showDivider
            :header="'Produktionshistorie'"
            :subHeader="''"
            :content="''"
          ></tile>
        </v-col>
        -->
          <!--
          <v-col v-if="showUsers" :lg="4" :md="4" :sm="12">
            <tile
              id="remainingDocumentsTile"
              name="remainingDocuments"
              routeTo="remainingDocuments"
              showDivider
              :header="'Verbleibende Dokumente'"
              :subHeader="''"
              :content="''"
            ></tile>
          </v-col>
          -->
          <v-col v-if="showUsers" :lg="4" :md="4" :sm="12">
            <tile
              id="usersTile"
              name="users"
              route-to="users"
              show-divider
              :header="'Nutzerverwaltung'"
              :sub-header="''"
              :content="''"
            ></tile>
          </v-col>
        </v-row>
      </v-layout>
    </v-content>
  </v-container>
</template>
<script>
import { cmsService } from '../services'
import Tile from '../components/Tile'
import dashboard from '../data/json/views/dashboard'
import { mapActions } from 'vuex'

export default {
  components: { Tile },
  data() {
    return {
      dialog: false,
      greeting: '',
      showUsers: this.$store.getters.isAdmin,
      content: dashboard.data
    }
  },
  created() {
    // save rules in Store
    this.fetchRules()
  },
  methods: {
    ...mapActions(['fetchRules']),
    closeDialog() {
      this.dialog = false
      this.$router.push('/dashboard')
    },
    getContent: function (name) {
      return cmsService.filterCMSContent(this.content, name)
    }
  }
}
</script>
